import type { ItemWithPrices } from 'analytics/utils/getEECItems/getEECItems'
import { create } from 'zustand'

export type AnalyticsImpressionsStore = {
	impressions: ItemWithPrices[]
	addImpression: (impression: ItemWithPrices) => void
	resetImpressions: () => void
}

export const useAnalyticsImpressionsStore = create<AnalyticsImpressionsStore>()(
	(set) => ({
		impressions: [],
		addImpression: (impression) =>
			set((state) => ({ impressions: state.impressions.concat(impression) })),
		resetImpressions: () => set(() => ({ impressions: [] })),
	})
)
